import Mapper from '@/models/mappers/Mapper';
import { ColorGroup } from '@/models/entities/ColorGroup';
import { ColorGroupDTO } from '@/api/dto/ColorGroupDTO';
import { mapValueToInterface } from '@/utils/models';

export class ColorGroupMapper extends Mapper<ColorGroup, ColorGroupDTO> {
  mapFromDTO(colorGroupDTO: ColorGroupDTO): ColorGroup {
    return new ColorGroup(<Partial<ColorGroup>>colorGroupDTO);
  }

  mapToDTO(colorGroup: ColorGroup): ColorGroupDTO {
    return mapValueToInterface(colorGroup) as ColorGroupDTO;
  }
}
